import React, { useState, useEffect, useRef } from "react";
import "./invoice.css";
import logo from "../../../Assets/jklogo.png";
import logo1 from "../../../Assets/jk.png"
import Sign from "../../../Assets/DirectorSign.png";
import Sign1 from "../../../Assets/DirectorSign1.png";
import Santlogo from "../../../Assets/SantGollogo.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import QRCode from "qrcode";
import PdfPreview from "../../../Common/PDFPreview";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";
import PrintButton from "../../../Common/Buttons/PrintPDF";
import HeaderJK from "../../../Assets/HeaderJK.png";
import FooterJK from "../../../Assets/FooterJK.png";
import FooterJK1 from "../../../Assets/FooterJK1.png";
import "../../../Common/Fonts/Signika-Bold-normal";
import "../../../Common/Fonts/Signika-Regular-normal";
import "../../../Common/Fonts/Signika-Medium-normal";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";


const API_URL = process.env.REACT_APP_API;

const HaladSaleBillDetailReport = ({ salebilldetailId, disabledFeild }) => {
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const [invoiceData, setInvoiceData] = useState([]);
    const [pdfPreview, setPdfPreview] = useState(null);
    const TCSApplicable = sessionStorage.getItem("TCSApplicable");
    const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
    const newCompanyName = sessionStorage.getItem("newCompanyName")
    const oldFormerlyName = sessionStorage.getItem("oldFormerlyName")


    const fetchData = async () => {
        try {
            const response = await fetch(
                `${API_URL}/generating_GulsaleBill_Detailreport?Company_Code=${companyCode}&Year_Code=${Year_Code}&salebilldetailId=${salebilldetailId}`
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();

            setInvoiceData(data.all_data);
            generatePdf(data.all_data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const generatePdf = async (data) => {

        const pdf = new jsPDF({ orientation: "portrait" });
        const allData = data?.[0] || {};

        const docDate = new Date(allData.doc_date);
        const cnameUpdatedDate = new Date(CompanyNameUpdatedDate);

        // const displayCompanyName =
        //   docDate < cnameUpdatedDate
        //     ? newCompanyName
        //     : allData.Company_Name_E;


        const logoToUse = docDate < cnameUpdatedDate ? Santlogo : Santlogo;
        const SignToUse = docDate < cnameUpdatedDate ? Sign1 : Sign;
        const foormerlyName = docDate < cnameUpdatedDate ? oldFormerlyName : allData.AL1;

        pdf.setFont("Signika-Regular");
        pdf.setFontSize(8);

        const logoImg = new Image();
        const signImg = new Image();
        // const headerImg = new Image();
        const footerImg = new Image();
        const footerImg1 = new Image();
        logoImg.src = Santlogo;
        // signImg.src = SignToUse;
        // headerImg.src = HeaderJK;
        // footerImg.src = FooterJK;
        // footerImg1.src = FooterJK1

        const qrCodeData = `
    GSTN of Supplier : ${allData.companyGSTNo || ""}
    GSTIN of Buyer : ${allData.billtogstno || ""}
    Document No. : ${allData.doc_no || ""}
    Document Type : Tax Invoice
    Date : ${allData.doc_date || ""}
    HSN : ${allData.HSN || ""}
    IRN : ${allData.einvoiceno || ""}
    `;
        const qrCodeDataUrl = await QRCode.toDataURL(qrCodeData.trim());

        logoImg.src = logoToUse;
        logoImg.onload = () => {

            const shouldUseImage =
                // docDate >= cnameUpdatedDate

                pdf.addImage(logoImg, "PNG", 12, 2, 25, 25);
            pdf.setFont("Signika-Bold");
            //   pdf.setFontSize(14);
            //   pdf.text(displayCompanyName, 45, 14);
            //   pdf.setFont("Signika-Regular");
            //   pdf.setFontSize(9);
            // pdf.setFont("Signika-Regular"); 
            //   pdf.setFontSize(9);
            //   pdf.text(`${foormerlyName}`, 45, 18);
            //   pdf.text(`${allData.AL2}`, 45, 22);
            //   pdf.text(`${allData.AL3}`, 45, 26);
            //   pdf.text(`${allData.AL4}`, 45, 30);
            //   pdf.text(`${allData.Other}`, 45, 34);
            //   pdf.text(`${allData.BillFooter}`,45,38)
            if (shouldUseImage) {
                // Use header image across top (new template)
                // pdf.addImage(headerImg, "PNG", 0, 6, 180, 34); // full width
            } else {
                // Old layout: logo + company name + address lines
                pdf.addImage(logoImg, "PNG", 10, 9, 30, 30);
                pdf.setFont("Signika-Bold");
                // pdf.setFontSize(14);
                // // pdf.text(displayCompanyName, 45, 14);
                // pdf.setFont("Signika-Regular");
                // pdf.setFontSize(9);
                // pdf.text(`${foormerlyName}`, 45, 18);
                // pdf.text(`${allData.AL2}`, 45, 22);
                // pdf.text(`${allData.AL3}`, 45, 26);
                // pdf.text(`${allData.AL4}`, 45, 30);
                // pdf.text(`${allData.Other}`, 45, 34);
                // pdf.text(`${allData.BillFooter}`, 45, 38);
            }
            // pdf.addImage(qrCodeDataUrl, "PNG", 170, 9, 30, 30);
            pdf.text("By Laws No 18 & 52, Schedule No 18 Bill", 105, 12, { align: "center" });
            // ======= CUSTOM HEADER WITHOUT IMAGE =======
            pdf.setFont("Signika-Medium");
            pdf.setFontSize(16);
            pdf.setTextColor(0, 0, 0);


            // Center the text header
            pdf.text("Sangli Krushi Utappan Bazar Samiti , Sangli", 105, 18, { align: "center" });

            // Optional: small subtitle
            pdf.setFont("Signika-Regular");
            pdf.setFontSize(10);

            // pdf.text("(Government Regd. Agricultural Market Committee)", 105, 26, { align: "center" });

            // Draw underline below header
            // pdf.setLineWidth(0.4);
            // pdf.setDrawColor(80, 80, 80);
            // pdf.line(10, 32, 200, 32);


            pdf.setFontSize(10);
            pdf.setFont("Signika-Bold");
            pdf.setDrawColor(80, 80, 80);
            pdf.setLineWidth(0.3);
            pdf.line(10, 27, 200, 27);
            pdf.setTextColor(41, 122, 14);
            pdf.text("", 95, 33);
            pdf.setFont("Signika-Medium");
            pdf.setTextColor(0, 0, 0);
            pdf.text(`Bill No: ${allData.doc_no}`, 12, 33);
            pdf.setFont("Signika-Medium");
            pdf.setTextColor(0, 0, 0);
            pdf.text(`Bill Date: ${allData.doc_date}`, 165, 33);
            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, 37, 200, 37);
            pdf.setTextColor(0, 0, 0);

            let y = 25;
            pdf.setFontSize(9);

            const fieldPairs = [
                [
                    `Company Name. :    AMOGHSIDDESHWAR TRADING CO.`,
                    ``,
                    `PAN NO. : AJSPB7107N`,
                ],
                [
                    `ADDRESS: Market Yard, Sangli 416416`,
                    ``,
                    `PHONE NO : (0233)2670614,9422500692`,
                ],
                [
                    ``,
                    ``,
                    ``,
                ],
                [
                    ``,
                    "",
                    ``,
                ],
                [
                    ``,
                    "",
                ],
                ["", "", "", ""],
            ];

            fieldPairs.forEach(([left1, left2, rightLabel, rightValue]) => {
                const leftX = 12;
                const middleX = 60;
                const rightX = 110;
                const wrapWidth = 85;
                const lineHeight = 4;

                const [rawLeftLabel, ...rawLeftValParts] = (left1 ?? "").split(":");
                const leftLabel = rawLeftLabel?.trim() ? `${rawLeftLabel.trim()}` : "";
                const leftValue = rawLeftValParts.join("").trim();
                const leftValueLines = pdf.splitTextToSize(leftValue, wrapWidth - pdf.getTextWidth(leftLabel));

                const left2Lines = pdf.splitTextToSize(left2 ?? "", wrapWidth);

                const rightLabelText = rightLabel?.trim() ? `${rightLabel.trim()}` : "";
                const rightValueText = rightValue?.toString().trim() ?? "";
                const rightValueLines = pdf.splitTextToSize(rightValueText, wrapWidth - pdf.getTextWidth(rightLabelText));

                const maxLines = Math.max(leftValueLines.length, left2Lines.length, rightValueLines.length);

                for (let i = 0; i < maxLines; i++) {
                    const yOffset = y + i * lineHeight + 17;

                    if (i === 0 && leftLabel) {
                        pdf.setFont("Signika-Medium");
                        pdf.text(leftLabel, leftX, yOffset);
                        pdf.setFont("Signika-Regular");
                        pdf.text(leftValueLines[i] ?? "", leftX + pdf.getTextWidth(leftLabel) + 1, yOffset);
                    } else if (leftValueLines[i]) {
                        pdf.setFont("Signika-Regular");
                        pdf.text(leftValueLines[i], leftX, yOffset);
                    }


                    if (left2Lines[i]) {
                        pdf.setFont("Signika-Regular");
                        pdf.text(left2Lines[i], middleX, yOffset);
                    }

                    if (i === 0 && rightLabelText) {
                        pdf.setFont("Signika-Medium");
                        pdf.text(rightLabelText, rightX, yOffset);
                        pdf.setFont("Signika-Regular");
                        pdf.text(rightValueLines[i] ?? "", rightX + pdf.getTextWidth(rightLabelText) + 1, yOffset);
                    } else if (rightValueLines[i]) {
                        pdf.setFont("Signika-Regular");
                        pdf.text(rightValueLines[i], rightX, yOffset);
                    }
                }

                y += maxLines * lineHeight;
            });

            const verticalX = 105;
            const topOfFieldPairs = 59;
            const bottomOfFieldPairs = y + 12;

            pdf.setDrawColor(80, 80, 80);
            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(verticalX, topOfFieldPairs, verticalX, bottomOfFieldPairs);

            // const addressBlock = (x, yStart, title, lines) => {
            //   let y = yStart;
            //   let lineHeight = 4;
            //   pdf.setFont("Signika-Regular");
            //   pdf.setTextColor(41, 122, 14);
            //   pdf.text(title, x, y);
            //   y += lineHeight;

            //   lines.forEach((line, index) => {
            //     const wrapped = pdf.splitTextToSize(String(line ?? ""), 85);
            //     pdf.setFont(index === 0 ? "Signika-Bold" : "Signika-Regular");
            //     if (index === 0) {
            //       pdf.setTextColor(41, 122, 14);
            //     } else {
            //       pdf.setTextColor(0, 0, 0);
            //     }

            //     pdf.text(wrapped, x, y);
            //     y += wrapped.length * lineHeight;
            //   });
            //   return y;
            // };

            //uniform Spacing
            // const addressBlock = (x, yStart, title, lines) => {
            //     let y = yStart;
            //     const lineHeight = 4; // same as other blocks

            //     // Title
            //     pdf.setFont("Signika-Medium");
            //     pdf.setTextColor(0, 0, 0);
            //     pdf.text(title, x, y + 10);
            //     y += lineHeight;

            //     // Body lines
            //     lines.forEach((line, index) => {
            //         const wrapped = pdf.splitTextToSize(String(line ?? ""), 85);

            //         // First line: bold and green, rest normal
            //         pdf.setFont(index === 0 ? "Signika-Bold" : "Signika-Regular");
            //         pdf.setTextColor(index === 0 ? 41 : 0, index === 0 ? 122 : 0, index === 0 ? 14 : 0);

            //         // Loop through each wrapped line to draw and increment y
            //         wrapped.forEach((wLine) => {
            //             pdf.text(wLine, x, y + 10);
            //             y += lineHeight; // uniform spacing
            //         });
            //     });

            //     return y; // returns new y-position to continue below this block
            // };

            const addressBlock = (x, yStart, title, lines) => {
                let y = yStart;
                const lineHeight = 4; // space between lines

                // Draw title
                pdf.setFont("Signika-Medium");
                pdf.setTextColor(0, 0, 0);
                pdf.text(title, x, y + 10);
                y += lineHeight + 10;

                // Compute maximum label width
                const labelWidth = Math.max(
                    ...lines.map(line => {
                        const [label] = line.split(":");
                        return pdf.getTextWidth(label.trim());
                    })
                );

                // Draw lines
                lines.forEach((line) => {
                    const [label, ...valueParts] = line.split(":");
                    const value = valueParts.join(":").trim();

                    // Draw label
                    pdf.setFont("Signika-Bold");
                    pdf.setTextColor(41, 122, 14); // green color for labels
                    pdf.text(label.trim() + ":", x, y);

                    // Draw value starting at fixed position
                    pdf.setFont("Signika-Regular");
                    pdf.setTextColor(0, 0, 0);
                    pdf.text(value, x + labelWidth + 2, y); // 2 units padding

                    y += lineHeight;
                });

                return y; // return updated y
            };



            const isRegular =
                allData.carporateSaleDoc !== 0 &&
                allData.carporateSaleDoc !== "" &&
                allData.selling_type === "P" &&
                allData.Delivery_type === "C";

            const fssaiNo = isRegular
                ? allData.FSSAI_BillTo
                : allData.carporateBillToFSSAI || allData.FSSAI_BillTo;

            const tanNo = isRegular
                ? allData.BillToTanNo
                : allData.Carporate_Tanno || allData.BillToTanNo;

            const billToLines = [
                `TALAI Name: ${isRegular
                    ? allData.tolaidarName
                    : allData.tolaidarName || allData.tolaidarName}`,


                `Total Bags: ${isRegular
                    ? allData.Quantity
                    : allData.Quantity}`,

                `Item Name: ${isRegular
                    ? `${allData.System_Name_E}`
                    : allData.System_Name_E
                        ? `${allData.System_Name_E}  `
                        : `${allData.System_Name_E}`
                }`,
                // `GST: ${isRegular
                //     ? allData.billtogstno
                //     : allData.CarporateBillToGst_No || allData.billtogstno
                // }`,

                // `PAN: ${isRegular
                //     ? allData.billtopanno
                //     : allData.Carporate_Pan || allData.billtopanno
                // }`,

                // fssaiNo ? `FSSAI: ${fssaiNo}` : null,
                // tanNo ? `TAN: ${tanNo}` : null,
            ].filter(Boolean);

            const fssaiShipTo = allData.FSSAI_ShipTo;
            const tanShipTo = allData.ShipToTanNo;

            const shipToLines = [
                `Rate: ${allData.Rate}`,
                `Amount: ${allData.Amount}`,
                // `City: ${allData.shiptocityname} (${allData.shiptocitystate} - ${allData.shiptogststatecode})`,
                // `GST: ${allData.shiptogstno}`,
                // `PAN: ${allData.shiptopanno}`,
                // fssaiShipTo ? `FSSAI: ${fssaiShipTo}` : null,
                // tanShipTo ? `TAN: ${tanShipTo}` : null,
            ].filter(Boolean); // removes null/undefined/empty


            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, y - 1, 200, y - 1);

            const addressStartY = y - 5;
            // setTextColor(0, 0, 0)
            const endYBill = addressBlock(12, addressStartY, "", billToLines);
            const endYShip = addressBlock(110, addressStartY, "", shipToLines);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(100, addressStartY + 5, 100, Math.max(endYBill, endYShip) - 2);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(
            //     10,
            //     Math.max( endYShip) - 8,
            //     200,
            //     Math.max( endYShip) - 8
            // );
            y = Math.max(endYBill, endYShip) + 12;

            const verticalStartAfterGap = addressStartY + 15;
            const verticalEnd = Math.max(endYShip);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(105, verticalStartAfterGap + 50, 105, verticalEnd + 8);


            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);

            pdf.setFont("Signika-Medium");
            pdf.setTextColor(41, 122, 14);

            pdf.text("Sr No", 19, y - 7, { align: "right" });
            // pdf.text("Additional Net Weight", 120, y + 7, { align: "center" });

            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(
                10,
                Math.max(endYBill, endYShip) + 7,
                200,
                Math.max(endYBill, endYShip) + 7
            );

            y += 5;

            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, y - 17, 200, y - 17);



            const amountX = 187;


            y += 8; // space below header
            const additionNetWtRaw = String(allData.additionNetWt || "");
            const additionNetWtArray = additionNetWtRaw
                .split("+")
                .map(v => v.trim())
                .filter(v => v !== "");

            const MAX_ROWS_PER_COLUMN = 10;
            const MAX_COLS = 5;

            const xPositions = [40, 70, 100, 130, 160]; // same as used for table columns

            // Draw column headers
            pdf.setFont("Signika-Bold"); // bold for headers
            for (let i = 0; i < MAX_COLS; i++) {
                pdf.text(`${i + 1}`, xPositions[i], y - 20, { align: "center" });
            }

            // Prepare table as a 2D array [row][column]
            const tableRows = Array.from({ length: MAX_ROWS_PER_COLUMN }, () => Array(MAX_COLS).fill(""));

            // Fill the table column-wise
            additionNetWtArray.forEach((val, index) => {
                const col = Math.floor(index / MAX_ROWS_PER_COLUMN);  // which column
                const row = index % MAX_ROWS_PER_COLUMN;             // row in that column
                if (col < MAX_COLS) {
                    tableRows[row][col] = val;
                }
            });

            // --- Render Table ---
            pdf.setFont("Signika-Regular");
            pdf.setTextColor(0, 0, 0);

            let yStart = y;
            tableRows.forEach((rowValues, rowIndex) => {
                pdf.text(String(rowIndex + 1), 16, yStart - 12, { align: "center" }); // Sr No

                rowValues.forEach((val, colIndex) => {
                    const xPositions = [40, 70, 100, 130, 160]; // x positions for columns
                    if (val) {
                        pdf.text(String(val), xPositions[colIndex], yStart - 12, { align: "center" });
                    }
                });

                // Row line
                pdf.setLineWidth(0.2);
                pdf.setDrawColor(200, 200, 200);
                pdf.line(10, yStart - 10, 200, yStart - 10);

                yStart += 7; // row height
            });

            y = yStart + 1; // small gap before totals

            // ---- Column-wise totals ----
            const columnTotals = Array(MAX_COLS).fill(0);

            tableRows.forEach(row => {
                row.forEach((val, colIndex) => {
                    const num = parseFloat(val);
                    if (!isNaN(num)) {
                        columnTotals[colIndex] += num;
                    }
                });
            });

            pdf.setFont("Signika-Bold");
            pdf.setTextColor(0, 0, 0);

            // "Total" label
            pdf.text("Total", 16, y - 10, { align: "center" });

            // Print totals under each column
            columnTotals.forEach((total, colIndex) => {
                if (total !== 0) {
                    pdf.text(
                        total.toFixed(2),        // or without toFixed if you want
                        xPositions[colIndex],
                        y - 10,
                        { align: "center" }
                    );
                }
            });

            // Totals from your data object (alldata)
            // const totalQty = Number(allData.Net_quantity || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });
            // const totalWeight = Number(allData.Net_weight || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });
            // const totalValue = Number(allData.SubTotal || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });

            // pdf.text(totalWeight, 142, y);       // Net Weight
            // pdf.text(`${totalQty} Qntl`, 112, y); // Quantity
            // pdf.text(totalValue, 197, y, { align: "right" }); // Value


            // const containerAmt = Number(allData.Container || 0);

            // pdf.setFont("Signika-Regular");
            // pdf.text("Container:", 130, y + 6, { align: "left" });
            // pdf.text(
            //     formatReadableAmount(containerAmt),
            //     197,
            //     y + 6,
            //     { align: "right" }
            // );


            // pdf.setFont("Signika-Bold");

            // const subTotalWithContainer =
            //     Number(allData.SubTotal || 0) + containerAmt;

            // pdf.text("Total + Container:", 130, y + 11);
            // pdf.text(
            //     formatReadableAmount(subTotalWithContainer),
            //     197,
            //     y + 11,
            //     { align: "right" }
            // );


            // Draw line above totals

            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(10, y + 4, 200, y + 4);
            pdf.line(10, y - 14, 200, y - 14);

            // Optional: line under totals
            pdf.line(10, y - 7, 200, y - 7);

            y += 8; // move cursor below totals if needed


            pdf.setFont("Signika-Regular");


            let currentY = y + 16;


            let fssai = String(allData.MillFSSAI_No ?? "").trim();
            if (fssai !== "") {
                // Manually insert breakable characters every 15 chars if needed
                if (fssai.length > 25 && !fssai.includes(" ")) {
                    fssai = fssai.match(/.{1,20}/g).join(" ");
                }

                const wrappedFSSAI = pdf.splitTextToSize(fssai, 100);
                pdf.text("Mill FSSAI:", 12, currentY);
                pdf.text(wrappedFSSAI, 28, currentY);
            }



            y += 10;

            // 1. Parse out your rates / amounts
            const igstRate = parseFloat(allData.IGSTRate) || 0;
            const igstAmt = parseFloat(allData.IGSTAmount) || 0;

            const cgstRate = parseFloat(allData.CGSTRate) || 0;
            const cgstAmt = parseFloat(allData.CGSTAmount) || 0;

            const sgstRate = parseFloat(allData.SGSTRate) || 0;
            const sgstAmt = parseFloat(allData.SGSTAmount) || 0;

            const taxRows = [];

            if (igstRate > 0) {
                // only IGST
                taxRows.push(["IGST", igstRate, igstAmt]);
            } else {
                taxRows.push(
                    //   ["CGST", cgstRate, cgstAmt],
                    //   ["SGST", sgstRate, sgstAmt]

                );
            }

            const totalBags = parseFloat(allData.Quantity) || 0;
            const bagSut = Number((totalBags * 0.5).toFixed(2));


            const summaryFields = [
                ...(allData.carporateSaleDoc === 0 ||
                    allData.carporateSaleDoc === "" ||
                    allData.carporateSaleDoc === null
                    ? [["Freight", allData.LESS_FRT_RATE, allData.freight]]
                    : []),

                // ["Taxable Amount", "", allData.SubTotal],
                ...taxRows,
                ["Total Weight", "", allData.GrossWt],
                ["Bags Sut", "", allData.BagSut],
                ["EXTRA Sut", "", allData.ExtraSut],
                // ["Dekrekh Fee", "", allData.DekhRekh],
                // ["Round Off", "", allData.RoundOff],

                // ...(TCSApplicable === "N"
                //     ? []
                //     : [
                //         ["TCS:", allData.TCS_Rate, allData.TCS_Amt],
                //         ["TCS Net Payable:", "", allData.TCS_Net_Payable],
                //     ]),
            ];


            let headingAdded = false; // ✅ to ensure heading appears only once

            summaryFields.forEach(([label, rate, amount]) => {
                // Add heading before "Taxable Amount" group
                // if (!headingAdded && ["Taxable Amount", "Leavy", "Commission", "Market Cess", "Dekrekh"].includes(label)) {
                //     pdf.setFont("Signika-Medium");
                //     pdf.setTextColor(41, 122, 14);
                //     pdf.text("Other Expenses", 130, y);
                //     pdf.text("Amount", 197, y, { align: "right" });
                //     y += 4; // space below heading
                //     headingAdded = true;
                // }

                // Draw each summary row
                pdf.setFont("Signika-Regular");
                pdf.setTextColor(0, 0, 0);

                pdf.text(`${label}:`, 130, y + 3);

                // Rate column (if exists)
                if (rate !== null && rate !== undefined && rate !== "") {
                    pdf.text(`${formatReadableAmount(rate)}%`, 165, y + 3, { align: "center" });
                }

                // Amount (formatted)
                const formattedAmount = formatReadableAmount(amount);
                pdf.text(formattedAmount, 197, y + 3, { align: "right" });

                y += 5;
            });




            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            pdf.line(10, y + 4, 200, y + 4);

            const totalAmount =
                Number(allData.Leavy || 0) +
                Number(allData.Commission || 0);
            // Number(allData.MarketCess || 0) +
            // Number(allData.DekhRekh || 0);

            const formattedTotal = formatReadableAmount(totalAmount);

            pdf.setFont("Signika-Bold");
            pdf.setTextColor(41, 122, 14);
            // pdf.text("Total Expenses:", 150, y + 9);
            pdf.text(`Total Weight`, 148, y + 9, { align: "right" });
            pdf.text(`${allData.Net_weight}`, 186, y + 9, { align: "left" });

            y += 5;
            pdf.setLineWidth(0.3);
            // pdf.line(10, y + 7, 200, y + 7);

            pdf.setFont("Signika-Bold");
            pdf.setTextColor(0, 0, 0);
            pdf.setFontSize(8);
            // pdf.text("Terms & Conditions:", 12, y + 12);
            // pdf.setFont("Signika-Regular");
            // const notes = [
            //     "- If there is no insurance of the goods, after dispatch from the destination,",
            //     "   we are not responsible for non delivery, damage or any kind of loss.",
            //     "- Buyer must inspect and confirm quality & quantity of the goods before dispatch from godown.",
            //     "   Once loaded and truck leaves godown, Said all responsibilities will be transfer to buyers account.",
            //     "- Please send the full amount in our account through RTGS before despatch the goods.",
            //     "   If the amount is not received in our account, Interest of 24% P.A. will be charged to the buyer.",
            //     `- Subject to ${allData.companyCity} jurisdiction.`
            // ];
            // notes.forEach((n, i) => pdf.text(n, 12, y + 13 + (i + 1) * 3));

            y += 25;
            if (allData.SBNarration) {
                pdf.text(`${allData.SBNarration}`, 12, y + 12)
            }
            const signY = y - 10;
            pdf.setFont("Signika-Bold");
            pdf.setFontSize(9);
            pdf.setTextColor(0, 0, 0);

            const signWidth = 240;
            const signHeight = signWidth / 5;

            y -= 80;

            const billY = y + 68;      // Bill Amount Y
            const payableY = y + 75;   // Payable Y

            // Draw LINE ABOVE Bill Amount
            pdf.setLineWidth(0.3);
            pdf.setDrawColor(80, 80, 80);
            // pdf.line(10, billY + 2, 200, billY + 2);

            const isMarketCessApplicable = allData.MarketCess === "Y";

            const dekhRekhAmt = isMarketCessApplicable
                ? Number(allData.DekhRekh || 0)
                : 0;

            const marketCessAmt = isMarketCessApplicable
                ? Number(allData.HeadMarketcess || 0)
                : 0;

            const baseBillAmount = Number(allData.SubTotal || 0)
                + Number(allData.Leavy || 0)
                + Number(allData.Commission || 0);

            const finalBillAmount = baseBillAmount + dekhRekhAmt + marketCessAmt;


            // pdf.addImage(signImg, "PNG", 157, y + 11, signWidth, signHeight);
            // pdf.setFont("Signika-Medium");
            // pdf.text("Bill Amount", 150, y + 75);

            // Value (right-aligned exactly like Amount column)
            // pdf.text(
            //     Number(finalBillAmount || 0).toLocaleString("en-IN", {
            //         minimumFractionDigits: 2,
            //         maximumFractionDigits: 2,
            //     }),
            //     197,
            //     y + 75,
            //     { align: "right" }
            // );

            // const totalInWords = ConvertNumberToWord(
            //     (finalBillAmount)
            // );
            // pdf.text(`Rs: ${totalInWords}.`, 12, y + 75);
            // const Total = Number(finalBillAmount || 0).toLocaleString(
            //     "en-IN",
            //     {
            //         minimumFractionDigits: 2,
            //         maximumFractionDigits: 2,
            //     }
            // );

            // pdf.line(10, payableY + 3, 200, payableY + 3);

            // pdf.text("Payable", 150, y + 85);

            // // Amount (right-aligned under Amount column)
            // pdf.text(
            //     Number(allData.Bill_Amount || 0).toLocaleString("en-IN", {
            //         minimumFractionDigits: 2,
            //         maximumFractionDigits: 2,
            //     }),
            //     197,
            //     y + 85,
            //     { align: "right" }
            // );


            // pdf.text(`Market Cess : ${allData.HeadMarketcess}`, 12, y + 85);
            // pdf.text(`Dekrekh Fee : ${allData.DekhRekh}`, 45, y + 85);

            const poweredByY = 292;

            pdf.setFont("Signika-Medium");
            pdf.setFontSize(7);
            pdf.setTextColor(0, 0, 0);
            pdf.text("Powered by: Sugarian.app", 12, poweredByY);

            const pdfBlob = pdf.output("blob");
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfPreview(pdfUrl);
        };
    }

    return (
        <div id="pdf-content">
            {pdfPreview && (
                <PdfPreview
                    pdfData={pdfPreview}
                    apiData={invoiceData[0]}
                    label={"SaleBill"}
                />
            )}
            <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} label={"Print"} />
        </div>
    );
};
export default HaladSaleBillDetailReport;
